export default {
  masterProducts: [],
  masterProduct: undefined,
};
